export namespace ModulePaths {
    export const DASHBOARD: string = 'dashboard';
    export const PROFILE: string = 'profile';
    export const AUDIT_TEMPLATE: string = 'audit-template';
    export const PERFORM_AUDIT: string = 'perform';
    export const SEARCH_AUDITS: string = 'search-audits';
    export const AUDIT_RESULTS: string = 'audit-results';
    export const BULK_ASSIGN: string = 'bulk-assign';
    export const HOME: string = 'home';
    export const AUTH: string = 'auth';
    export const AUTH_FAILED: string = `authentication-failed`;
    export const FORGOT_PASSWORD: string = `forgot-password`;
    export const GRADE_RULE: string = 'grade-rule';
    export const SETTINGS: string = 'settings';
    export const ASSIGN_SCHEDULE_VISIT: string = 'assign-schedule-visit';
    export const AUDIT_VISIT = 'audit-visit';
    export const FACILITY_REPORT = 'facility-report';
    export const SWITCH_USER = 'switch-user';
    export const CALENDAR = 'calendar';
    export const GRADE_RULE_LIST = 'grade-rule-list';
    export const GRADE_RULE_DETAILS = 'grade-rule-details';
    export const CREATE_AUDIT = 'create-audit';
    export const ERROR = 'error';
    export const PUBLIC = 'public';
}
